module.exports = __webpack_public_path__ + "images/3-ru.65c859320937f687c825df19906cefcb.jpg";